import Card from '@/components/ui/Card'

export default function TowerSMBsAbout() {
  return (
    <div className="space-y-8">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold text-cocoa">Tower for SMBs</h1>
        <span className="inline-flex items-center gap-2 rounded-full bg-shell px-3 py-1 text-sm font-medium uppercase tracking-wide text-cocoa/70">
          Preview — Coming soon
        </span>
        <p className="text-cocoa/70">
          Sponsor local classrooms as part of your community impact. We’re co-designing packages with small businesses in our network.
        </p>
      </header>
      <Card className="p-5 text-sm text-cocoa/80">
        From co-branded storytelling to on-site showcases, we’re curating the right ways for businesses to invest in young builders. Join the waitlist by reaching out through our contact form.
      </Card>
    </div>
  )
}
